import React, {useRef, useState, useEffect, useDeferredValue, useCallback} from 'react';
import {
    Typography,
    Slider,
    Box,
    Stack,
    Paper,
    Popover,
    Rating,
    Button,
    ListItem,
    List,
    Divider,
    ListItemText, ButtonGroup
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import BlurredComponent from "../common/BlurredComponent";

import PropTypes from "prop-types";
import AlertDialog from "../common/Dialog";

import { useWebSocket } from "../net/WebSocketContext";
import {Scoreboard} from "@mui/icons-material";
import Display from "../display/Display";
import Skating from "./Skating";
import ScoreDots from "./ScoreDots";
import StrictlyCard from "./StrictlyCard";

const styles = {
    box: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden', // Запрет прокрутки
    },
};

const typographyProps = {
    variant: "caption",
    gutterBottom: true,
    styles: {
        //marginBottom:'-2px'
    }
}

const typographyPropsOverline = {
    variant: "overline",
    gutterBottom: true,
    position: 'fixed',
    marginTop: '306px',
    marginLeft: '100px',
    color: 'orange',
    fontWeight: '900',
    fontSize: '15px'
}

const StackProps = {
    sx: {
        height: 120,
        mb: '40px',
        marginBottom: '48px',
        marginTop: '38px'

    },
    spacing: 0.1,
    direction: "row"
}
function ValueLabelComponent(props) {
    const {children, value} = props;
    return (
        <Tooltip
            placement="top"
            title={value}
            enterDelay={50}
            leaveDelay={50}
            leaveTouchDelay={50}
            enterTouchDelay={50}
            slotProps={{
                tooltip: {
                    sx: {
                        fontSize: '40px', textAlign: 'right'
                    }
                }
            }}
        >
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.node
};

const Judging = ({darkMode, zoom}) => {
    const {
        ws,
        isConnected,
        loading,
        progress,
        judging_start,
        judging_done,
        judging_clear,
        judging_refresh,
        display
    } = useWebSocket();
    const [wait, setWait] = useState(false);
    const sliderRef = useRef(null);
    const [isIOS, setIsIOS] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [isDone, setIsDone] = useState(false);
    const [isRoundEnd, setRoundEnd] = useState(false);
    const [complete, setComplete] = useState(false);
    // const [isStrictly, setStrictly] = useState(false);
    // const [isJandJ, setJandJ] = useState(false);
    // const [isSkating, setSkating] = useState(false);
    const [judType,setJudType] = useState("")

    const [role, setRole] = useState("leaders");
    const [places, setPlaces] = useState(() => {
        return (JSON.parse(localStorage.getItem("judging_places")) || [])
    });
    const last_cards = useRef(null);
    const [jjBalls, setJjBalls] = useState(false);
    const [display_, setDisplay_] = useState(false);
    const [jjBallsLeft, setJjBallsLeft] = useState(() => {
        return (
            JSON.parse(localStorage.getItem("judging_jjBallsLeft")) ||
            false)
    });
    const [sliderValues, setSliderValues] = useState(() => {
        const savedSliderValues = localStorage.getItem("judging_sliderValues");
        if (savedSliderValues) {
            try {
                return JSON.parse(savedSliderValues);
            } catch (e) {
                console.error("Error parsing slider values from localStorage:", e);
                return [
                    {
                        basic_leader: 0,
                        basic_follow: 0,
                        lfbdh: 0,
                        dance_perf: 0,
                        execution: 0,
                        diff_var: 0,
                        interpret: 0,
                        spontan: 0
                    },
                    {
                        basic_leader: 0,
                        basic_follow: 0,
                        lfbdh: 0,
                        dance_perf: 0,
                        execution: 0,
                        diff_var: 0,
                        interpret: 0,
                        spontan: 0
                    }
                ];
            }
        }
        return [
            {
                basic_leader: 0,
                basic_follow: 0,
                lfbdh: 0,
                dance_perf: 0,
                execution: 0,
                diff_var: 0,
                interpret: 0,
                spontan: 0
            },
            {
                basic_leader: 0,
                basic_follow: 0,
                lfbdh: 0,
                dance_perf: 0,
                execution: 0,
                diff_var: 0,
                interpret: 0,
                spontan: 0
            }
        ];
    });
    const [radioValues, setRadioValues] = useState(() => {
        const savedRadioValues = localStorage.getItem("judging_radioValues");
        if (savedRadioValues) {
            try {
                return JSON.parse(savedRadioValues);
            } catch (e) {
                console.error("Error parsing radio values from localStorage:", e);
                return [
                    {
                        bonus1: 0,
                        bonus2: 0,
                        bonus3: 0,
                    },
                    {
                        bonus1: 0,
                        bonus2: 0,
                        bonus3: 0,
                    }
                ];
            }
        }
        return [
            {
                bonus1: 0,
                bonus2: 0,
                bonus3: 0,
            },
            {
                bonus1: 0,
                bonus2: 0,
                bonus3: 0,
            }
        ];
    });
    const vibrate1 = () => {
        if ("vibrate" in navigator) {
            navigator.vibrate([
                10,
            ]); // Паттерн вибрации
    };
    }
    const vibrate2 = () => {
        if ("vibrate" in navigator) {
            navigator.vibrate([
                20,
            ]); // Паттерн вибрации
        };
    }
    const zeroCard = () =>{
        setSliderValues([
            {
                basic_leader: 0,
                basic_follow: 0,
                lfbdh: 0,
                dance_perf: 0,
                execution: 0,
                diff_var: 0,
                interpret: 0,
                spontan: 0
            },
            {
                basic_leader: 0,
                basic_follow: 0,
                lfbdh: 0,
                dance_perf: 0,
                execution: 0,
                diff_var: 0,
                interpret: 0,
                spontan: 0
            }
        ])
        setRadioValues([
            {
                bonus1: 0,
                bonus2: 0,
                bonus3: 0,
            },
            {
                bonus1: 0,
                bonus2: 0,
                bonus3: 0,
            }
        ])
        // Очищаем localStorage при сбросе карточек
        localStorage.removeItem("judging_sliderValues");
        localStorage.removeItem("judging_radioValues");
    }
    const Ready = () => {
            const sendOnOpen = () => {
                let body = {}
                if(judType === 'Strictly'){
                    body = {
                        action: "judging_ready",
                        complete: complete,
                        jud_type: judType,
                        cards: [
                            {
                                place: places?.[0],
                                ...places?.[0],
                                ...sliderValues?.[0],
                                ...radioValues?.[0]
                            },
                            {
                                place: places?.[1],
                                ...places?.[1],
                                ...sliderValues?.[1],
                                ...radioValues?.[1]
                            }
                        ]
                    }
                        //zeroCard()
                }
                else if(judType === 'J&J'){
                    let cards = [];
                    (places ?? []).map( place => {
                        if(place?.[ role === "leaders" ? "leader" : "follower"  ]?.id){
                            cards.push({
                                place,
                                ...place
                            })
                        }
                    })
                    body = {
                        action: "judging_ready",
                        complete: complete,
                        cards,
                        role,
                        jud_type: judType
                    }
                }
                else if(judType === 'Skating'){
                let cards = places
                body={
                        action: 'judging_ready',
                        complete:  complete,
                        cards: cards,
                        jud_type: judType
                    }
                }
                ws.zsend(JSON.stringify(body));
                console.log("SEND:", body);
                setIsReady(false)
                // Очищаем localStorage после отправки результатов
                localStorage.removeItem("judging_sliderValues");
                localStorage.removeItem("judging_radioValues");
            };

        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
        // },[isReady]);
    }

    const  syncArrayByPlace = (first, second) => {
        // Удаляем элементы, которых нет во втором
        for (let i = first.length - 1; i >= 0; i--) {
            const place = first[i].place;
            if (!second.some(obj => obj.place === place)) {
                first.splice(i, 1);
            }
        }

        // Добавляем элементы из второго, которых нет в первом
        second.forEach(item => {
            const exists = first.some(obj => obj.place === item.place);
            if (!exists) {
                first.push(item);
            }
        });

        return first
    }

    useEffect(() => {
        localStorage.setItem("judging_places", JSON.stringify(places));
    }, [places]);

    useEffect(() => {
        localStorage.setItem("judging_jjBallsLeft", JSON.stringify(jjBallsLeft));
    }, [jjBallsLeft]);

    useEffect(() => {
        localStorage.setItem("judging_sliderValues", JSON.stringify(sliderValues));
    }, [sliderValues]);

    useEffect(() => {
        localStorage.setItem("judging_radioValues", JSON.stringify(radioValues));
    }, [radioValues]);

    // Пишем в WS  action: "judging_get"
    useEffect(() => {
        judgingGet()
    },[isConnected]);
    // Пишем в WS  action: 'judging_cards',
    useEffect(() => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        const sendOnOpen = () => {
            sendCards()
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };

    },[sliderValues, radioValues, complete]);
    // Читаем WS

    useEffect(() => {
        if(judging_start) {
            //console.log("BY judging_start:", places)
            console.log("ON_MESSAGE judging_start", judging_start)
            setDisplay_(false)
            setIsDone(false)
            setWait(false)
            setRoundEnd(judging_start?.end)
            //console.log("DANCE: ",judging_start?.cards?.[0]?.dance)
            //console.log("CATEGORY: ",judging_start?.cards?.[0]?.category)
            if (
                //judging_start?.cards?.[0]?.category === 'Strictly' ||
                judging_start?.cards?.[0]?.jud_type === 'Strictly') {
                setJudType("Strictly")
                setIsReady(true)
                // setStrictly(true)
                // setJandJ(false)
                // setSkating(false)
                //setPlacesIn(judging_start?.cards)
                setPlaces(syncArrayByPlace(places, judging_start?.cards))

            } else if
            (
                //judging_start?.cards?.[0]?.category === 'J&J' ||
                judging_start?.cards?.[0]?.jud_type === 'J&J') {
                if (!judging_start?.end) {
                    setIsReady(true)
                }
                setJudType("J&J")
                // setJandJ(true)
                // setStrictly(false)
                // setSkating(false)
                setPlaces(syncArrayByPlace(places, judging_start?.cards))
                if (!jjBalls) {
                    setJjBalls(judging_start?.jjBalls)
                    if (!jjBallsLeft) {
                        console.log("set setJjBallsLeft", jjBallsLeft)
                        setJjBallsLeft(judging_start?.jjBalls)
                    }

                }
            } else if (judging_start?.cards?.[0]?.jud_type === 'Skating') {
                setJudType("Skating")
                setIsReady(true)
                // setJandJ(false)
                // setStrictly(false)
                // setSkating(true)
                setPlaces(syncArrayByPlace(places, judging_start?.cards))
            } else {

            }
            if (judging_start?.judging_list) {
                const rl = judging_start?.judging_list?.leaders.find(j => j === localStorage.getItem('id')) ? "leaders" : "followers"
                console.log("RL", rl)
                setRole(rl)
            }
            setWait(false)
        }
    }, [judging_start]);

    useEffect(() => {
        if(judging_done) {
            console.log("ON_MESSAGE judging_done", judging_done)
            setDisplay_(false)
            console.log("DEEP FETCH  :", judging_done?.cards)
            console.log("DEEP CURRENT:", last_cards.current)
            if (deepEqual(judging_done?.cards, last_cards.current)) {
                setDisplay_(true)
                //setJandJ(false)
                setJjBallsLeft(false)
                setJjBalls(false)
                setJudType("")
                setIsReady(false)
                setPlaces([])
                zeroCard()
                setComplete(complete ? false : false)
                setIsDone(true)
                setWait(false)
            } else {
                sendCards()
            }
        }
    }, [judging_done]);

    useEffect(() => {
        if (judging_clear) {
            console.log("ON_MESSAGE judging_clear", judging_clear)
            setDisplay_(true)
            // setJandJ(false)
            setJudType("")
            setPlaces([])
            setJjBallsLeft(false)
            setJjBalls(false)
            setIsReady(false)
            setComplete(complete ? false : false)
            setIsDone(true)
            setWait(false)
            // Очищаем localStorage при сбросе судейства
            localStorage.removeItem("judging_sliderValues");
            localStorage.removeItem("judging_radioValues");
        }
    }, [judging_clear]);

    useEffect(() => {
        if(judging_refresh) {
            console.log("ON_MESSAGE Judging", judging_refresh)
            judgingGet()
            // Очищаем localStorage при обновлении данных
            localStorage.removeItem("judging_sliderValues");
            localStorage.removeItem("judging_radioValues");
        }
    }, [judging_refresh]);

    useEffect(() => {
        if(display){
        console.log("ON_MESSAGE Judging", display)
        setDisplay_(true)
        }
    }, [display]);

    // useEffect(() => { // Читаем WS
    //                 if (isConnected && ws_data) {
    //                     console.log("ON_MESSAGE Judging", ws_data)
    //
    //                     if(ws_data?.type === 'judging_clear'){
    //
    //                     }
    //                     if(ws_data?.type === 'judging_refresh'){
    //
    //                     }
    //                     if(ws_data?.type === 'display'){
    //                         setDisplay_(true)
    //                     }
    //                 }
    // },[ws_data]);

    useEffect(() => {
        setIsIOS([
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document));
        //console.log(isIOS)
    }, []); // IOS detected Пустой массив зависимостей — выполняется один раз после первого рендера

    const judgingGet = () => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        const sendOnOpen = () => {
            setWait(true)
            let body = {
                action: "judging_get",
                role
            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body);
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }
    const sendCards = () => {
        if(complete){
            setWait(true)
            let cards = []
            if(judType === 'Strictly'){
                cards = [
                    {
                        place: places?.[0] ?? null,
                        ...places?.[0],
                        ...sliderValues?.[0],
                        ...radioValues?.[0]
                    },
                    {
                        place: places?.[1] ?? null,
                        ...places?.[1],
                        ...sliderValues?.[1],
                        ...radioValues?.[1]
                    }
                ]
            }
             if( judType === 'J&J' || judType === 'Skating' ){
                 cards = places
             }
            last_cards.current = cards
            const body={
                action: 'judging_cards',
                complete:  complete,
                cards: cards,
                jud_type: judType
            }

            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body)
            setIsReady(false)
        }
    }
    const deepEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true; // Если ссылаются на один объект

        if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null)
            return false; // Если это примитивы или один null

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false; // Если разное число ключей

        return keys1.every((key) => deepEqual(obj1[key], obj2[key])); // Рекурсивно сравниваем значения
    };

    const sliderProps = {
        sx: {
            height: '100px'
        },
        orientation: "vertical",
        defaultValue: 0,
        shiftStep: 0.5,
        step: 0.5,
        min: 0,
        valueLabelDisplay: 'auto',
        slots: {
            valueLabel: ValueLabelComponent,
        }
    };

    const marks = [
        {
            "value": 0,
            "label": "0"
        },
        {
            "value": 0.5,
            "label": ""
        },
        {
            "value": 1,
            "label": "1"
        },
        {
            "value": 1.5,
            "label": ""
        },
        {
            "value": 2,
            "label": "2"
        },
        {
            "value": 2.5,
            "label": ""
        },
        {
            "value": 3,
            "label": "3"
        },
        {
            "value": 3.5,
            "label": ""
        },
        {
            "value": 4,
            "label": "4"
        },
        {
            "value": 4.5,
            "label": ""
        },
        {
            "value": 5,
            "label": "5"
        }
    ];//createMarks(values);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleToolTip = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const divProps = {
        style: {
            width: '73px'
        }
    }

    const PopoverProps1 = {
        open: open,
        anchorEl: anchorEl,
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center",
        }
    }

    const pointCountProps = {
        style: {
            position: 'fixed',
            marginLeft: '0px',
            marginTop: '-37px',
            fontSize: '20px',
            //border: '1px dashed #ffa500',
            width: '44px',
            height: '26px',
            textAlign: 'center',
            color: darkMode ?  '#ffa500': '#000',
            alignContent: 'center',
            boxShadow: '0 1px 2px 0 #000000',
            backgroundColor: darkMode ? '#000' : '#FFF',
        }
    }

    const pointCountProps1 = {
        style: {
            position: 'fixed',
            marginLeft: '-20px',
            marginTop: '-37px',
            fontSize: '20px',
            //border: '1px dashed #ffa500',
            width: '44px',
            height: '26px',
            textAlign: 'center',
            color: darkMode ?  '#ffa500': '#000',
            alignContent: 'center',
            boxShadow: '0 1px 2px 0 #000000',
            backgroundColor: darkMode ? '#000' : '#FFF',
        }
    }

    const radioGroupProps = {
        sx: {height: '77px', marginTop: '10px'},
        //ariaLabelledby: "demo-controlled-radio-buttons-group",
        name: "controlled-radio-buttons-group"
    }
    const onChangeSliders = (card_number, sliderName) => (event, newValue) => {
        // onChange we want to block duplicate mouse down release events
        if (isIOS && event.type === "mousedown") {
            return;
        } else {
            //console.log(newValue, event)
            vibrate1()
            //console.log(newValue, card_number, sliderName)
            setSliderValues((prevState) => {
                    let e = prevState.map((group, index) =>
                        index === card_number  ? {...group, [sliderName]: newValue} : group
                    )
                    return(e)
                }
            )
        }
    }
    const onChangeJJ = (card_number, name) => (event) => {
            //console.log(card_number, name, event)
            vibrate1()
            //console.log(newValue, card_number, sliderName)
            setPlaces((prevState) => {
                    let e = [...prevState]
                    if (name === "yes") {
                        if (e[card_number]?.jj === 100){
                            e[card_number] = {...e[card_number], jj: 0}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, yes: ((prevState?.yes*1) + 1)}
                            })
                        }
                        else if (e[card_number]?.jj === 51){
                            e[card_number] = {...e[card_number],jj: 100}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, yes: ((prevState?.yes*1) - 1)}
                            })
                            setJjBallsLeft((prevState) => {
                                return {...prevState, maybe: ((prevState?.maybe*1) + 1)}
                            })
                        }
                        else {
                            e[card_number] = {...e[card_number], jj: 100}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, yes: ((prevState?.yes*1) - 1)}
                            })
                        }
                    } else {
                        if (e[card_number]?.jj === 51){
                            e[card_number] = {...e[card_number], jj: 0}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, maybe: ((prevState?.maybe*1) + 1)}
                            })
                        }
                        else if(e[card_number]?.jj === 100){
                            e[card_number] = {...e[card_number], jj: 51}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, maybe: ((prevState?.maybe*1) - 1)}
                            })
                            setJjBallsLeft((prevState) => {
                                return {...prevState, yes: ((prevState?.yes*1) + 1)}
                            })
                        }
                        else {
                            e[card_number] = {...e[card_number], jj: 51}
                            setJjBallsLeft((prevState) => {
                                return {...prevState, maybe: ((prevState?.maybe*1) - 1)}
                            })
                        }

                    }
                    return e
                }
            )
    }
    const onChangeRadio= (card_number, bonusName) => (event, newValue) => {
                vibrate2();
                setRadioValues((prevState) => {
                    let e = prevState.map((group, index) =>
                        index === card_number  ? {...group, [bonusName]: newValue} : group
                    )
                    return(e)
                }
            )

    }
    const getSliderValue = () => {
        if (sliderRef.current) {
            console.log("Текущее значение:", sliderRef.current.querySelector("input").value);
        }
    };

    const onChangeBall = useCallback((card_number, sliderName) => (value) => {
        //console.log(newValue, event)
        //vibrate1()
        console.log("onChangeBall called with:", value, card_number, sliderName)
        setSliderValues((prevState) => {
                let e = prevState.map((group, index) =>
                    index === card_number  ? {...group, [sliderName]: value} : group
                )
                return(e)
            }
        )
    }, []);

    const onChangeBallBonus = useCallback((card_number, sliderName) => (value) => {
        //console.log(newValue, event)
        //vibrate1()
        console.log("onChangeBallBonus called with:", value, card_number, sliderName)
        setRadioValues((prevState) => {
                let e = prevState.map((group, index) =>
                    index === card_number  ? {...group, [sliderName]: value} : group
                )
                return(e)
            }
        )
    }, []);


    const  getColor = (val, min, max) => {
        // ограничиваем значение диапазоном
        val = Math.max(min, Math.min(val, max));

        // нормализация в диапазон 0–1
        const ratio = (val - min) / (max - min);


        // hue: 0 (red) → 120 (green)
        const hue = ratio * 120;

        // параметры подобраны под белый текст
        const saturation = 80; // насыщенность
        const lightness = 35;  // темнота (ключевой параметр)

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }





    return (
        <>

        {
            judType === 'Strictly' ?
                // <Box sx={styles.box} sx={{
                //     userSelect: "none", // Запрещает выделение текста
                //     WebkitUserSelect: "none", // Для Safari
                //     MozUserSelect: "none", // Для Firefox
                //     MsUserSelect: "none", // Для Internet Explorer
                //
                //     transform: `scale(${zoom})`, // Меняем масштаб
                //     transformOrigin: "top", // Центрируем масштабирование
                //     transition: "transform 0.3s ease-in-out", // Плавный эффект
                //     display: "flex",
                //     flexDirection: "column",
                //     alignItems: "center",
                //     justifyContent: "top",
                //     height: "100vh",
                //     position: 'fixed'
                // }}>
                //     <Box spacing={0} sx={{width: '95%',}}>
                //         <AlertDialog
                //             name = 'Готово'
                //             main_message= 'Отправить результаты карточки?'
                //             message = 'Все разультаты будут отправлены и записаны'
                //             ok =  'Отправить'
                //             cancel = 'Подумаю еще'
                //             okFn={()=>{
                //                 setComplete(true)
                //             }}
                //             sx={{
                //                 position: 'fixed',
                //                 zIndex: '10',
                //                 marginLeft: "290px",
                //                 marginTop: "-45px"
                //             }}
                //             enabled={isReady || isDone }
                //             />
                //         <Button
                //             onClick={()=>(Ready())}
                //             variant="outlined"
                //             style={{
                //                 position: 'fixed',
                //                 zIndex: '10',
                //                 marginLeft: "160px",
                //                 marginTop: "-45px",
                //                 display: isReady ? 'block' : 'none'
                //             }}
                //             color="primary">
                //             начинаем?</Button>
                //         {/*<Button*/}
                //         {/*    style={{*/}
                //         {/*        position: 'fixed',*/}
                //         {/*        zIndex: '10',*/}
                //         {/*        marginLeft: "132px",*/}
                //         {/*        marginTop: "-45px",*/}
                //         {/*    }}*/}
                //         {/*    onClick={judgingGet}*/}
                //         {/*    variant="contained" color="primary">*/}
                //         {/*    получить</Button>*/}
                //         <BlurredComponent isBlurred={!isConnected || wait || loading} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"}>
                //             { ( places?.[0] ?? null ) ?
                //                 <Paper elevation={3} sx={{ padding: 1,textAlign: "center", mb: 1}}>
                //                     <Typography {...typographyPropsOverline}>{ "ПАРА "+places?.[0]?.number }</Typography>
                //                     <Stack  {...StackProps} >
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[0].basic_leader}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(0, 'basic_leader')}
                //                                     key={'basic_leader'}
                //                                     value={sliderValues[0].basic_leader}/>
                //                             <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>basic
                //                                 leader</Typography>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[0].basic_follow}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(0, 'basic_follow')}
                //                                     key={'basic_follow'}
                //                                     value={sliderValues[0].basic_follow}/>
                //                             <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>basic
                //                                 follower</Typography>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[0].lfbdh}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(0, 'lfbdh')}
                //                                     key={'lfbdh'}
                //                                     value={sliderValues[0].lfbdh}/>
                //                             <Typography {...typographyProps} sx={{marginLeft: "-10px", fontSize: "0.6rem"}}
                //                                         id="1"
                //                                         onClick={handleToolTip}>L&F
                //                                 BD H</Typography>
                //                             <Popover {...PopoverProps1}>
                //                                 <Box sx={{p: 2, maxWidth: 300}}>
                //                                     <Typography variant="body2">
                //                                         Lead and Follow, Basic Dancing, Harmony
                //                                     </Typography>
                //                                 </Box>
                //                             </Popover>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[0].dance_perf}</Typography>
                //                             <Slider {...sliderProps} marks={marks} max={4}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(0, 'dance_perf')}
                //                                     key={'dance_perf'}
                //                                     value={sliderValues[0].dance_perf}/>
                //                             <Typography {...typographyProps} sx={{marginLeft: "-25px", fontSize: "0.6rem"}}>Dance
                //                                 Perf</Typography>
                //                         </div>
                //                         <div {...divProps} >
                //                             <Typography {...pointCountProps}>{radioValues[0].bonus1}</Typography>
                //                             <RadioGroup
                //
                //                                 sx={{
                //                                     height: '77px',
                //                                     marginTop: '10px'
                //                                 }}
                //                                 aria-labelledby="demo-controlled-radio-buttons-group"
                //                                 name="controlled-radio-buttons-group"
                //                                 value={radioValues[0].bonus1}
                //                                 onChange={onChangeRadio(0, 'bonus1')}
                //                             >
                //                                 <FormControlLabel
                //                                     sx={{marginLeft: '-12px'}}
                //                                     slotProps={{
                //                                         typography: {
                //                                             sx: {
                //                                                 fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                             }
                //                                         }
                //                                     }} value="1" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                                 <FormControlLabel slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                                 <FormControlLabel slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>}
                //                                                   label="0"/>
                //                             </RadioGroup>
                //                             <Typography {...typographyProps}
                //                                         sx={{marginLeft: "-50px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                         </div>
                //                     </Stack>
                //                     <Stack  {...StackProps} style={{marginBottom: "10px"}}>
                //                     <div style={{width: "53px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[0].execution}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={5}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(0, 'execution')}
                //                                 key={'execution'}
                //                                 value={sliderValues[0].execution}/>
                //                         <Typography {...typographyProps}
                //                                     sx={{fontSize: "0.6rem"}}>Execution</Typography>
                //                     </div>
                //                     <div style={{width: "75px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[0].diff_var}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={4}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(0, 'diff_var')}
                //                                 key={'diff_var'}
                //                                 value={sliderValues[0].diff_var}/>
                //                         <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>Diff.
                //                             Var.</Typography>
                //                     </div>
                //                     <div style={{width: "33px"}}>
                //                         <Typography {...pointCountProps1}>{radioValues[0].bonus2}</Typography>
                //                         <RadioGroup {...radioGroupProps}
                //                                     value={radioValues[0].bonus2}
                //                                     onChange={onChangeRadio(0, 'bonus2')}
                //                         >
                //                             <FormControlLabel
                //                                 sx={{marginLeft: '-12px'}}
                //                                 slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="1"
                //                                 control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0"/>
                //                         </RadioGroup>
                //                         <Typography {...typographyProps}
                //                                     sx={{marginLeft: "-17px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                     </div>
                //                     <div style={{width: "55px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[0].interpret}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={5}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(0, 'interpret')}
                //                                 key={'interpret'}
                //                                 value={sliderValues[0].interpret}/>
                //                         <Typography {...typographyProps}
                //                                     sx={{fontSize: "0.6rem"}}>Interpret.</Typography>
                //                     </div>
                //                     <div {...divProps}>
                //                         <Typography {...pointCountProps}>{sliderValues[0].spontan}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={4}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(0, 'spontan')}
                //                                 key={'spontan'}
                //                                 value={sliderValues[0].spontan}/>
                //                         <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>Spontan.</Typography>
                //                     </div>
                //                     <div {...divProps}>
                //                         <Typography {...pointCountProps1}>{radioValues[0].bonus3}</Typography>
                //                         <RadioGroup {...radioGroupProps}
                //                                     value={radioValues[0].bonus3}
                //                                     onChange={onChangeRadio(0, 'bonus3')}
                //                         >
                //                             <FormControlLabel
                //                                 sx={{marginLeft: '-12px'}}
                //                                 slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="1" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0"/>
                //                         </RadioGroup>
                //                         <Typography {...typographyProps}
                //                                     sx={{marginLeft: "-50px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                     </div>
                //                 </Stack>
                //                 </Paper> : ''}
                //             { ( places?.[1] ?? null ) ?
                //                 <Paper elevation={3} sx={{ padding: 1, textAlign: "center", mb: 1 }}>
                //                     <Typography {...typographyPropsOverline}>{ "ПАРА " +places?.[1]?.number }</Typography>
                //                     <Stack  {...StackProps} >
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[1].basic_leader}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(1, 'basic_leader')}
                //                                     key={'basic_leader'}
                //                                     value={sliderValues[1].basic_leader}/>
                //                             <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>basic
                //                                 leader</Typography>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[1].basic_follow}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(1, 'basic_follow')}
                //                                     key={'basic_follow'}
                //                                     value={sliderValues[1].basic_follow}/>
                //                             <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>basic
                //                                 follower</Typography>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[1].lfbdh}</Typography>
                //                             <Slider {...sliderProps} ref={sliderRef} marks={marks} max={5}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(1, 'lfbdh')}
                //                                     key={'lfbdh'}
                //                                     value={sliderValues[1].lfbdh}/>
                //                             <Typography {...typographyProps} sx={{marginLeft: "-10px", fontSize: "0.6rem"}}
                //                                         id="1"
                //                                         onClick={handleToolTip}>L&F
                //                                 BD H</Typography>
                //                             <Popover {...PopoverProps1}>
                //                                 <Box sx={{p: 2, maxWidth: 300}}>
                //                                     <Typography variant="body2">
                //                                         Lead and Follow, Basic Dancing, Harmony
                //                                     </Typography>
                //                                 </Box>
                //                             </Popover>
                //                         </div>
                //                         <div {...divProps}>
                //                             <Typography {...pointCountProps}>{sliderValues[1].dance_perf}</Typography>
                //                             <Slider {...sliderProps} marks={marks} max={4}
                //                                     disabled={isReady}
                //                                     onChange={onChangeSliders(1, 'dance_perf')}
                //                                     key={'dance_perf'}
                //                                     value={sliderValues[1].dance_perf}/>
                //                             <Typography {...typographyProps} sx={{marginLeft: "-25px", fontSize: "0.6rem"}}>Dance
                //                                 Perf</Typography>
                //                         </div>
                //                         <div {...divProps} >
                //                             <Typography {...pointCountProps}>{radioValues[1].bonus1}</Typography>
                //                             <RadioGroup
                //                                 sx={{
                //                                     height: '77px',
                //                                     marginTop: '10px'
                //                                 }}
                //                                 aria-labelledby="demo-controlled-radio-buttons-group"
                //                                 name="controlled-radio-buttons-group"
                //                                 value={radioValues[1].bonus1}
                //                                 onChange={onChangeRadio(1, 'bonus1')}
                //                             >
                //                                 <FormControlLabel
                //                                     sx={{marginLeft: '-12px'}}
                //                                     slotProps={{
                //                                         typography: {
                //                                             sx: {
                //                                                 fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                             }
                //                                         }
                //                                     }} value="1" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                                 <FormControlLabel slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                                 <FormControlLabel slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>}
                //                                                   label="0"/>
                //                             </RadioGroup>
                //                             <Typography {...typographyProps}
                //                                         sx={{marginLeft: "-50px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                         </div>
                //                     </Stack>
                //                     <Stack  {...StackProps} style={{marginBottom: "10px"}}>
                //                     <div style={{width: "53px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[1].execution}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={5}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(1, 'execution')}
                //                                 key={'execution'}
                //                                 value={sliderValues[1].execution}/>
                //                         <Typography {...typographyProps}
                //                                     sx={{fontSize: "0.6rem"}}>Execution</Typography>
                //                     </div>
                //                     <div style={{width: "75px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[1].diff_var}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={4}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(1, 'diff_var')}
                //                                 key={'diff_var'}
                //                                 value={sliderValues[1].diff_var}/>
                //                         <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>Diff.
                //                             Var.</Typography>
                //                     </div>
                //                     <div style={{width: "33px"}}>
                //                         <Typography {...pointCountProps1}>{radioValues[1].bonus2}</Typography>
                //                         <RadioGroup {...radioGroupProps}
                //                                     value={radioValues[1].bonus2}
                //                                     onChange={onChangeRadio(1, 'bonus2')}
                //                         >
                //                             <FormControlLabel
                //                                 sx={{marginLeft: '-12px'}}
                //                                 slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="1"
                //                                 control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0"/>
                //                         </RadioGroup>
                //                         <Typography {...typographyProps}
                //                                     sx={{marginLeft: "-17px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                     </div>
                //                     <div style={{width: "55px"}}>
                //                         <Typography {...pointCountProps}>{sliderValues[1].interpret}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={5}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(1, 'interpret')}
                //                                 key={'interpret'}
                //                                 value={sliderValues[1].interpret}/>
                //                         <Typography {...typographyProps}
                //                                     sx={{fontSize: "0.6rem"}}>Interpret.</Typography>
                //                     </div>
                //                     <div {...divProps}>
                //                         <Typography {...pointCountProps}>{sliderValues[1].spontan}</Typography>
                //                         <Slider {...sliderProps} marks={marks} max={4}
                //                                 disabled={isReady}
                //                                 onChange={onChangeSliders(1, 'spontan')}
                //                                 key={'spontan'}
                //                                 value={sliderValues[1].spontan}/>
                //                         <Typography {...typographyProps} sx={{fontSize: "0.6rem"}}>Spontan.</Typography>
                //                     </div>
                //                     <div {...divProps}>
                //                         <Typography {...pointCountProps1}>{radioValues[1].bonus3}</Typography>
                //                         <RadioGroup {...radioGroupProps}
                //                                     value={radioValues[1].bonus3}
                //                                     onChange={onChangeRadio(1, 'bonus3')}
                //                         >
                //                             <FormControlLabel
                //                                 sx={{marginLeft: '-12px'}}
                //                                 slotProps={{
                //                                     typography: {
                //                                         sx: {
                //                                             fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                         }
                //                                     }
                //                                 }} value="1" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="1"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0.5" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0.5"/>
                //                             <FormControlLabel slotProps={{
                //                                 typography: {
                //                                     sx: {
                //                                         fontSize: "0.9rem", marginLeft: '2px', marginTop: '4px'
                //                                     }
                //                                 }
                //                             }} value="0" control={<Radio disabled={isReady} style={{padding: 0}}/>} label="0"/>
                //                         </RadioGroup>
                //                         <Typography {...typographyProps}
                //                                     sx={{marginLeft: "-50px", fontSize: "0.6rem"}}>Bonus</Typography>
                //                     </div>
                //                 </Stack>
                //                 </Paper> : ''}
                //         </BlurredComponent>
                //     </Box>
                // </Box>
                <Box sx={styles.box} sx={{
                    userSelect: "none", // Запрещает выделение текста
                    WebkitUserSelect: "none", // Для Safari
                    MozUserSelect: "none", // Для Firefox
                    MsUserSelect: "none", // Для Internet Explorer
                    transform: `scale(${zoom})`, // Меняем масштаб
                    transformOrigin: "top", // Центрируем масштабирование
                    transition: "transform 0.3s ease-in-out", // Плавный эффект
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "top",
                    height: "100vh",
                    position: 'fixed'
                }}>
                    <Box spacing={0} sx={{width: '100%',}}>
                        <AlertDialog
                            name = 'Готово'
                            main_message= 'Отправить результаты карточки?'
                            message = 'Все разультаты будут отправлены и записаны'
                            ok =  'Отправить'
                            cancel = 'Подумаю еще'
                            okFn={()=>{
                                setComplete(true)
                            }}
                            sx={{
                                position: 'fixed',
                                zIndex: '10',
                                marginLeft: "290px",
                                marginTop: "-45px"
                            }}
                            enabled={isReady || isDone }
                            />
                        <Button
                            onClick={()=>(Ready())}
                            variant="outlined"
                            style={{
                                position: 'fixed',
                                zIndex: '10',
                                marginLeft: "160px",
                                marginTop: "-45px",
                                display: isReady ? 'block' : 'none'
                            }}
                            color="primary">
                            начинаем?</Button>
                        <BlurredComponent isBlurred={!isConnected || wait || loading} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"}>
                            <div style={{paddingLeft: '20px', userSelect: 'none'}}>
                                { ( places?.[0] ?? null ) ? <StrictlyCard 
                                    key={`strictly-card-0`}
                                    index={0} 
                                    places={places} 
                                    sliderValues={sliderValues} 
                                    radioValues={radioValues}
                                    onChangeBall={onChangeBall}
                                    onChangeBallBonus={onChangeBallBonus}
                                    isReady={isReady}
                                    getColor={getColor}
                                /> : "" }
                                { ( places?.[1] ?? null ) ? <StrictlyCard 
                                    key={`strictly-card-1`}
                                    index={1} 
                                    places={places} 
                                    sliderValues={sliderValues} 
                                    radioValues={radioValues}
                                    onChangeBall={onChangeBall}
                                    onChangeBallBonus={onChangeBallBonus}
                                    isReady={isReady}
                                    getColor={getColor}
                                /> : "" }
                            </div>
                        </BlurredComponent>
                    </Box>
                </Box>
                : (
                    judType === 'J&J' ?
                        <>
                            <AlertDialog
                                name='Готово'
                                main_message='Отправить результаты карточки?'
                                message='Все разультаты будут отправлены и записаны'
                                ok='Отправить'
                                cancel='Подумаю еще'
                                okFn={() => {
                                    setComplete(true)
                                }}
                                sx={{
                                    position: 'fixed',
                                    zIndex: '10',
                                    marginLeft: "290px",
                                    marginTop: "-45px"
                                }}
                                enabled={!isRoundEnd}
                            />
                            <Button
                                onClick={() => (Ready())}
                                variant="outlined"
                                style={{
                                    position: 'fixed',
                                    zIndex: '10',
                                    marginLeft: "160px",
                                    marginTop: "-45px",
                                    display: isReady ? 'block' : 'none'
                                }}
                                color="primary">
                                начинаем?</Button>
                            <Stack direction="row" spacing={1}>
                                <ButtonGroup sx={{paddingLeft: 2}} size="small" variant="text"
                                             aria-label="Basic button group">
                                    <Button variant={role === "leaders" ? "contained" : "outlined"} onClick={() => {
                                        setRole("leaders")
                                    }}>leaders</Button>
                                    <Button variant={role === "followers" ? "contained" : "outlined"} onClick={() => {
                                        setRole("followers")
                                    }}>followers</Button>
                                </ButtonGroup>
                                <Button variant={"text"}>YES {jjBallsLeft?.yes ?? '_'}/{jjBalls?.yes ?? '_'}</Button>
                                <Button variant={"text"}>MAYBE {jjBallsLeft?.maybe ?? '_'}/{jjBalls?.maybe ?? '_'}</Button>
                            </Stack>
                            <Divider sx={{paddingBottom: 0}}/>
                            <List
                                sx={{
                                    pt: 0,
                                    height: (window.innerHeight - 100) + 'px',
                                    overflow: 'auto'
                                }}
                                aria-label="mailbox folders">
                                {
                                    (places ?? []).map((place, index) => {
                                        return (
                                            role === "leaders" && place?.leader?.id ?
                                                <div key={index}>
                                                    <ListItem>
                                                        <ListItemText sx={{width: 50}} primary={place?.number}/>
                                                        <ListItemText sx={{width: 200}} primary={place?.leader?.name}/>
                                                        <ButtonGroup size="small" variant="text"
                                                                     aria-label="Basic button group">
                                                            <Button
                                                                disabled={((jjBallsLeft?.yes > 0) || places[index]?.jj === 100) ? isReady : true}
                                                                variant={places[index]?.jj === 100 ? "contained" : "text"}
                                                                onClick={onChangeJJ(index, 'yes')}>yes</Button>
                                                            <Button
                                                                disabled={((jjBallsLeft?.maybe > 0) || places[index]?.jj === 51) ? isReady : true}
                                                                variant={places[index]?.jj === 51 ? "contained" : "text"}
                                                                onClick={onChangeJJ(index, 'maybe')}>maybe</Button>
                                                        </ButtonGroup>
                                                    </ListItem>
                                                    <Divider component="li"/>
                                                </div>
                                                :
                                                (role === "followers" && place?.follower?.id ?
                                                    <div key={index}>
                                                        <ListItem>
                                                            <ListItemText sx={{width: 50}} primary={place?.number}/>
                                                            <ListItemText sx={{width: 200}}
                                                                          primary={place?.follower?.name}/>
                                                            <ButtonGroup size="small" variant="text"
                                                                         aria-label="Basic button group">
                                                                <Button
                                                                    disabled={((jjBallsLeft?.yes > 0) || places[index]?.jj === 100) ? isReady : true}
                                                                    variant={places[index]?.jj === 100 ? "contained" : "text"}
                                                                    onClick={onChangeJJ(index, 'yes')}>yes</Button>
                                                                <Button
                                                                    disabled={((jjBallsLeft?.maybe > 0) || places[index]?.jj === 51) ? isReady : true}
                                                                    variant={places[index]?.jj === 51 ? "contained" : "text"}
                                                                    onClick={onChangeJJ(index, 'maybe')}>maybe</Button>
                                                            </ButtonGroup>
                                                        </ListItem>
                                                        <Divider component="li"/>
                                                    </div> : "")
                                        )
                                    })
                                }
                            </List>

                        </>
                        : (
                            judType === 'Skating' ?
                                <Skating
                                    isRoundEnd={isRoundEnd}
                                    setComplete={setComplete}
                                    Ready={Ready}
                                    isReady={isReady}
                                    isDone={isDone}
                                    places={places}
                                    setPlaces={setPlaces}

                                ></Skating>
                                : ('')))}
        </>
    );
};

export default Judging;